const SERASA_APP_ICON =
  'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F9ed75d6d3177479fa60c63cddf4077db?format=SVG&width=144'

const DOWNLOAD_APP_URL = 'http://serasa.news/app_serasa'

export { DOWNLOAD_APP_URL, SERASA_APP_ICON }
